export default __webpack_public_path__ + "imgs/back_to_top.png";